import { useCallback, useState } from "react";
import { CityInput } from "./city-input";
import { City } from "./city-input/types";
import { useLocationFilters } from "./hooks/use-location-filters";
import { SpaceInput } from "./space-input";
import { Space } from "./space-input/types";

interface LocationFiltersProps {
  location: string;
  onSubmit?: boolean;
  onChange?: (value: { id: string; name: string }[] | null) => void;
}

export function LocationFilters({
  location,
  onSubmit,
  onChange,
}: LocationFiltersProps) {
  const { data, isLoading, searchParams, setSearchParams } =
    useLocationFilters();
  const [selectedCity, setSelectedCity] = useState<City[] | null>(null);
  const [selectedSpaces, setSelectedSpaces] = useState<Space[] | null>(null);

  const handleChange = useCallback(
    (value: City[] | Space[] | null, type: "cities" | "spaces") => {
      if (type === "cities") {
        setSelectedCity(value as City[]);
      }
      if (type === "spaces") {
        setSelectedSpaces(value as Space[]);
      }
      onChange?.(value);
    },
    [onChange],
  );

  return (
    <>
      <CityInput
        location={location}
        data={data?.cities || []}
        isLoading={isLoading}
        selectedSpaces={selectedSpaces}
        onSubmit={onSubmit ?? false}
        onChange={(value: City[] | null) => handleChange(value, "cities")}
      />
      <SpaceInput
        location={location}
        data={data?.spaces || []}
        isLoading={isLoading}
        selectedCity={selectedCity}
        onSubmit={onSubmit ?? false}
        onChange={(value: Space[] | null) => handleChange(value, "spaces")}
      />
    </>
  );
}
